import { WarrantyApi } from 'api/Warranty'
import AddWarranty from 'components/Main/Warranty/Warranty/AddWarranty'
import useActions from 'elements/Hooks/useActions'
import useFetch from 'elements/Hooks/useFetch'
import useModalData from 'elements/Hooks/useModalData'
import { get, isEmpty } from 'lodash'
import React, { useEffect } from 'react'
import { withRouter } from 'react-router-dom'

function AddWarrantyCont({ owner, match, templateKey, history }, ...props) {
  const key = owner || get(match, 'params.key')
  //console.log('key',key)

  const { data, fetching, fetch } = useFetch({
    url: `/warranty/${key}`,
    dependencyArray: [key],
    dontFetch: !key,
    suppressAlert: true,
  })

  const { submitting, submit: _submit, removing, remove, formRef, update, onShow, updating } = useModalData(
    WarrantyApi.create,
    WarrantyApi.update,
    WarrantyApi.remove,
    fetch
  )

  async function submit(newData) {
    const submitted = await _submit(newData)
    if (submitted)
      history.push({
        pathname: `/warranty/${key}/`,
      })
  }
  useEffect(() => {
    onShow(data, 'edit')
  }, [fetching])

  const actions = useActions('warranty', data, () => fetch(), WarrantyApi.operation)

  return (
    <AddWarranty
      {...{
        ...actions,
        data,
        fetching,
        fetch,
        owner,
        formRef,
        submit,
        update,
        isNew: isEmpty(data),
        removing,
        remove,
        submitting,
        updating,
      }}
    />
  )
}

export default withRouter(AddWarrantyCont)
